import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

/* Layout */
import Layout from '@/layout'

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: () => import('@/views/dashboard/index'),
      meta: { title: '我的工作台' },
    }]
  },
  {
    path: '/toolbox',
    name: 'ToolBox',
    redirect: '/toolbox/figure',
    component: Layout,
    meta: { title: '工具任务箱' },
    children: [{
      path: 'acquisition',
      name: 'Acquisition',
      component: () => import('@/views/acquisition/index'),
      meta: { title: '数据采集', icon: 'shujucaiji' }
    }, {
      path: 'figures',
      name: 'Figures',
      component: () => import('@/views/figures/index'),
      meta: { title: '图裂变', icon: 'tuliebian' }
    }, {
      path: 'figures/detail',
      name: 'FiguresDetail',
      hidden: true,
      component: () => import('@/views/figures/detail'),
      meta: { title: '图裂变详情' }
    }, {
      path: 'figures3',
      name: 'Figures3',
      component: () => import('@/views/figures3/index'),
      meta: { title: '图裂变3.0', icon: 'tuliebian' }
    }, {
      path: 'figures3/detail',
      name: 'Figures3Detail',
      hidden: true,
      component: () => import('@/views/figures3/detail'),
      meta: { title: '图裂变3.0详情' }
    }, {
      path: 'texts',
      name: 'Texts',
      component: () => import('@/views/texts/index'),
      meta: { title: '文生图', icon: 'wenshengtu' }
    }, {
      path: 'texts/detail',
      name: 'TextsDetail',
      hidden: true,
      component: () => import('@/views/texts/detail'),
      meta: { title: '文生图详情' }
    }, {
      path: 'setPicture',
      name: 'SetPicture',
      component: () => import('@/views/setPicture/index'),
      meta: { title: '商品套图', icon: 'shangpintaotu' }
    }, {
      path: 'setPicture/detail',
      name: 'SetPictureDetail',
      hidden: true,
      component: () => import('@/views/setPicture/detail'),
      meta: { title: '商品套图' },
    }, {
      path: 'textReplace',
      name: 'TextReplace',
      component: () => import('@/views/textReplace/index'),
      meta: { title: '文本替换', icon: 'wenbentihuan' }
    }, {
      path: 'textReplace/detail',
      name: 'TextReplaceDetail',
      hidden: true,
      component: () => import('@/views/textReplace/detail'),
      meta: { title: '文本替换详情' }
    }, {
      path: 'printExtract',
      name: 'PrintExtract',
      component: () => import('@/views/printExtract/index'),
      meta: { title: '印花提取', icon: 'yinhuatiqu' }
    }, {
      path: 'printExtract/detail',
      name: 'PrintExtractDetail',
      hidden: true,
      component: () => import('@/views/printExtract/detail'),
      meta: { title: '印花提取详情' }
    }, {
      path: 'magnify',
      name: 'Magnify',
      component: () => import('@/views/magnify/index'),
      meta: { title: '图片放大', icon: 'fangda' }
    }, {
      path: 'magnify/detail',
      name: 'MagnifyDetail',
      hidden: true,
      component: () => import('@/views/magnify/detail'),
      meta: { title: '图片放大详情' }
    }, {
      path: 'matting',
      name: 'Matting',
      component: () => import('@/views/matting/index'),
      meta: { title: '一键抠图', icon: 'koutu' }
    }, {
      path: 'matting/detail',
      name: 'MattingDetail',
      hidden: true,
      component: () => import('@/views/matting/detail'),
      meta: { title: '抠图详情' }
    }, {
      path: 'extractTitle',
      name: 'ExtractTitle',
      component: () => import('@/views/extractTitle/index'),
      meta: { title: '标题提取', icon: 'biaotitiqu' }
    }, {
      path: 'extractTitle/detail',
      name: 'ExtractTitleDetail',
      hidden: true,
      component: () => import('@/views/extractTitle/detail'),
      meta: { title: '标题提取详情' }
    }, {
      path: 'infringement',
      name: 'Infringement',
      component: () => import('@/views/infringement/index'),
      meta: { title: '侵权检测', icon: 'tuxiangqinquan' }
    }, {
      path: 'infringement/detail',
      name: 'InfringementDetail',
      hidden: true,
      component: () => import('@/views/infringement/detail'),
      meta: { title: '侵权检测详情' }
    }]
  },
  {
    path: '/teamResource',
    name: 'TeamResource',
    redirect: '/teamResource/template',
    component: Layout,
    meta: { title: '团队资源管理' },
    children: [{
      path: 'template',
      name: 'Template',
      component: () => import('@/views/template/index'),
      meta: { title: '套图模板', icon: 'taotumoban' },
    }, {
      path: 'exportTemp',
      name: 'ExportTemp',
      component: () => import('@/views/exportTemp/index'),
      meta: { title: '模板管理', icon: 'mobanguanli' }
    },
      // {
      //   path: 'texts',
      //   name: 'Texts',
      //   // component: () => import('@/views/appointment/arrange/index'),
      //   meta: { title: '文生图', icon: 'table' }
      // }, {
      //   path: 'texts',
      //   name: 'Texts',
      //   // component: () => import('@/views/appointment/arrange/index'),
      //   meta: { title: '一键抠图', icon: 'table' }
      // }, {
      //   path: 'texts',
      //   name: 'Texts',
      //   // component: () => import('@/views/appointment/arrange/index'),
      //   meta: { title: '商品套图', icon: 'table' }
      // }, {
      //   path: 'texts',
      //   name: 'Texts',
      //   // component: () => import('@/views/appointment/arrange/index'),
      //   meta: { title: '标题提取', icon: 'table' }
      // }
    ]
  }, {
    path: '/teamResource/template/detail',
    name: 'TemplateDetail',
    hidden: true,
    component: () => import('@/views/template/detail'),
    meta: { title: '模版详情' },
  },
  {
    path: '/material',
    component: Layout,
    redirect: '/material/index',
    children: [{
      path: 'index',
      name: 'Material',
      component: () => import('@/views/material/index'),
      meta: { title: '我的素材资产' },
    }]
  },
  {
    path: '/finished',
    component: Layout,
    redirect: '/finished/index',
    children: [{
      path: 'index',
      name: 'Finished',
      component: () => import('@/views/finished/index'),
      meta: { title: '成品管理' },
    }]
  },
  {
    path: '/colors',
    component: Layout,
    redirect: '/colors/index',
    children: [{
      path: 'index',
      name: 'Colors',
      component: () => import('@/views/colors/index'),
      meta: { title: '常用颜色规格' },
    }]
  },
  {
    path: '/subaccount',
    name: 'Subaccount',
    redirect: '/subaccount/index',
    component: Layout,
    meta: { title: '账号管理' },
    children: [{
      path: 'index',
      name: 'SubaccountIndex',
      component: () => import('@/views/subaccount/index'),
      meta: { title: '账号列表' }
    }]
  },
  {
    path: '/shop',
    name: 'Shop',
    redirect: '/shop/index',
    component: Layout,
    children: [{
      path: 'index',
      name: 'ShopIndex',
      component: () => import('@/views/shop/index'),
      meta: { title: '店铺管理' }
    }]
  },
  {
    path: '/accountManage',
    name: 'AccountManage',
    redirect: '/accountManage/index',
    // hidden: true,
    component: Layout,
    children: [{
      path: 'index',
      name: 'AccountManageIndex',
      component: () => import('@/views/accountManage/index'),
      meta: { title: '账号管理' }
    }]
  },
  {
    path: '/recharge',
    name: 'Recharge',
    redirect: '/recharge/index',
    // hidden: true,
    component: Layout,
    children: [{
      path: 'index',
      name: 'RechargeIndex',
      component: () => import('@/views/recharge/index'),
      meta: { title: '账号充值' }
    }]
  },
  {
    path: '/login',
    name: 'Login',

    component: () => import('@/views/login/index.vue')
  },
  {
    path: '/register',
    name: 'Register',

    component: () => import('@/views/register/index.vue')
  },
  {
    path: '/forgetPassword',
    name: 'ForgetPassword',

    component: () => import('@/views/forgetPassword/index.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

let whiteList = ['/login', '/register', '/forgetPassword']

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem("37aiToken")
  if (token) {
    // 有 token 的情况
    if (to.path === '/login') {
      if (to.query && to.query.client_id == 'chrome_extends') {
        // 如果已经登录但插件又访问登录页
        next()
      } else {
        // 如果已经登录又访问登录页，跳转到首页
        next('/')
      }
    } else {
      next()
    }
  } else {
    if (whiteList.indexOf(to.path) != -1) {
      next()
    } else {
      next('/login')
    }
  }
  //  || to.meta.title
  if (to.path != '/dashboard' && to.path != '/login' && to.path != '/register' && to.path != '/forgetPassword') {
    document.title = to.meta.title; // 根据路由动态设置标题
  } else {
    document.title = '37pod ai'; // 默认标题
  }
})

export default router
